export default "__VITE_ASSET__BGptCZcg__"